import React, { useState, useEffect } from "react";
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem,
    TableRow, Table,
    TableHead,
    TableBody,
    TableCell,
    Select,
    IconButton,
    Tooltip,
} from "@material-ui/core";
import CategoryService from "./Locality/Service/categoryService";
import * as Yup from 'yup';
import { Typography } from "../../components/Wrappers/Wrappers";
import TablePagination from '@material-ui/core/TablePagination';
import { Grid, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from '@material-ui/core/styles';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "rgb(255, 107, 129)",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    tableOverflow: {
        overflowX: 'auto',
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
}));

export default function Category() {
    const tableHeaders = ['Category', 'Status', 'Actions'];
    const classes = useStyles();
    const [categoryList, setCategoryList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
    const [categoryToDelete, setCategoryToDelete] = React.useState(null);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(5);
    const [category, setCategory] = useState({
        category: '',
        status: true,
    });

    const validationSchema = Yup.object().shape({
        category: Yup.string().required('Category is required'),
        status: Yup.boolean().required('Status is required'),
    });

    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    };

    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    };

    useEffect(() => {
        getCategoryList();
        return () => {
            setCategoryList([]);
        };
    }, []);

    const getCategoryList = () => {
        CategoryService.getAllCategory().then((res) => {
            setCategoryList(res);
        }).catch((err) => {
            console.error(err);
            alert("Error fetching categories: " + (err.response?.data?.message || err.message));
        });
    };

    const handleOpen = () => {
        setCategory({
            category: '',
            status: true,
        });
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCategory({
            category: '',
            status: true,
        });
    };

    const editCategory = (categoryItem) => {
        const obj = {
            _id: categoryItem._id,
            category: categoryItem.category || '',
            status: categoryItem.status !== undefined ? categoryItem.status : true,
        };
        setCategory(obj);
        setOpen(true);
    };

    const handleDeleteClick = (categoryItem) => {
        setCategoryToDelete(categoryItem);
        setDeleteDialogOpen(true);
    };

    const handleDeleteConfirm = () => {
        if (categoryToDelete) {
            CategoryService.deleteCategory(categoryToDelete).then((res) => {
                getCategoryList();
                setDeleteDialogOpen(false);
                setCategoryToDelete(null);
                alert("Category Deleted Successfully.");
            }).catch((err) => {
                alert("Error deleting category: " + (err.response?.data?.message || err.message));
            });
        }
    };

    const handleDeleteCancel = () => {
        setDeleteDialogOpen(false);
        setCategoryToDelete(null);
    };

    const formik = useFormik({
        initialValues: category,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            if (category._id) {
                values._id = category._id;
                CategoryService.updateCategory(values).then((res) => {
                    handleClose();
                    getCategoryList();
                    resetForm();
                    setCategory({
                        category: '',
                        status: true,
                    });
                    alert("Category Updated Successfully.");
                }).catch((err) => {
                    alert("Error updating category: " + (err.response?.data?.message || err.message));
                });
            } else {
                CategoryService.createCategory(values).then((res) => {
                    getCategoryList();
                    resetForm();
                    handleClose();
                    setCategory({
                        category: '',
                        status: true,
                    });
                    alert("Category Added Successfully.");
                }).catch((err) => {
                    alert(err.response?.data?.message || "Error adding category");
                });
            }
        },
    });

    return (
        <>
            <PageTitle title="Category Master" button={<Button
                variant="contained" onClick={handleOpen}
                size="medium"
                color="secondary" style={{ backgroundColor: 'rgb(112, 57, 177)' }}> Add Category
            </Button>} />
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                        <Table className="mb-0">
                            <TableHead>
                                <TableRow>
                                    {tableHeaders.map(key => (
                                        <StyledTableCell key={key}>{key}</StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {categoryList.slice(pg * rpg, pg * rpg + rpg).map((categoryItem) => (
                                    <TableRow key={categoryItem._id}>
                                        <TableCell className="pl-3 fw-normal">{categoryItem.category}</TableCell>
                                        <TableCell className="pl-3 fw-normal">
                                            <Typography
                                                size="sm"
                                                color={categoryItem.status ? "success" : "secondary"}
                                            >
                                                {categoryItem.status ? "Active" : "Inactive"}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Tooltip title="Edit">
                                                <IconButton
                                                    aria-label="edit"
                                                    onClick={() => editCategory(categoryItem)}
                                                    color="primary"
                                                >
                                                    <EditIcon />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Delete">
                                                <IconButton
                                                    aria-label="delete"
                                                    onClick={() => handleDeleteClick(categoryItem)}
                                                    color="secondary"
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <TablePagination
                            component="div"
                            count={categoryList.length}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>

            {/* Add/Edit Dialog */}
            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle>
                    {category._id ? "Edit Category" : "Add Category"}
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        style={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container spacing={3} style={{ marginTop: 8 }}>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    id="category"
                                    name="category"
                                    label="Category"
                                    type="text"
                                    variant="outlined"
                                    margin="dense"
                                    onChange={formik.handleChange}
                                    value={formik.values.category}
                                    error={formik.touched.category && Boolean(formik.errors.category)}
                                    helperText={formik.touched.category && formik.errors.category}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth variant="outlined" margin="dense">
                                    <InputLabel id="status-label">Status</InputLabel>
                                    <Select
                                        labelId="status-label"
                                        id="status"
                                        name="status"
                                        value={formik.values.status}
                                        onChange={formik.handleChange}
                                        label="Status"
                                        error={formik.touched.status && Boolean(formik.errors.status)}
                                    >
                                        <MenuItem value={true}>Active</MenuItem>
                                        <MenuItem value={false}>Inactive</MenuItem>
                                    </Select>
                                    {formik.touched.status && formik.errors.status && (
                                        <Typography size="sm" color="error" style={{ marginTop: 8, marginLeft: 14 }}>
                                            {formik.errors.status}
                                        </Typography>
                                    )}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="secondary">
                        Cancel
                    </Button>
                    <Button
                        onClick={formik.handleSubmit}
                        color="primary"
                        variant="contained"
                        style={{ backgroundColor: 'rgb(112, 57, 177)' }}
                    >
                        {category._id ? "Update" : "Add"}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Delete Confirmation Dialog */}
            <Dialog open={deleteDialogOpen} onClose={handleDeleteCancel}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <Typography>
                        Are you sure you want to delete the category "{categoryToDelete?.category}"? This action cannot be undone.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteCancel} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDeleteConfirm} color="secondary" variant="contained">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

